import store from '@/store'

import StatusService from '@/service/status/StatusService'

export default [{
  name: 'cardsales',
  path: '/cardsales',
  component: require('@/views/cardsales/Cardsales.vue').default
}, {
  name: 'cardsales/form',
  path: '/cardsales/form',
  beforeEnter(to, from, next) {
    let status = store.getters['status/getStatus']
    if (StatusService.statuses.NO_CFA_ACCOUNT.code === status.code) {
      next()
    }
  },
  component: require('@/views/cardsales/Form.vue').default
}, {
  name: 'cardsales/failure',
  path: '/cardsales/failure',
  component: require('@/views/cardsales/Failure.vue').default,
  props: true
}, {
  name: 'cardsales/list',
  path: '/cardsales/list',
  component: require('@/views/cardsales/List.vue').default
}]
